// extracted by mini-css-extract-plugin
module.exports = {"page_header":"styles_page_header__1kNKv"};